<template>
  <div class="dashboard-retention-container">
    <vs-card class="m-4">
      <div class="flex flex-shrink">
        <vs-input
            v-model="exerciseDate"
            type="date"
            label="Fecha del ejercicio"></vs-input>

        <div class="button-container">
          <vs-button
              @click="getSummaryData()"
              class="ml-4 mt-6">Actualizar</vs-button>
        </div>
      </div>
    </vs-card>
    <template v-if="result !== null">
      <csd-summary-card
          :csd-pending="result.csd_summary.pending_validation"
          :csd-valid="result.csd_summary.valid"
          :csd-with-error="result.csd_summary.with_error"
          :csd-without-load="result.csd_summary.without_load"
          :csd-loaded="result.csd_summary.loaded"
          :invoice-required="result.csd_summary.invoice_required" />

        <order-invoice-alert
          ref="orderInvoiceAlert"
          :date="exerciseDate" />

      <vs-card class="m-4" title="Resultados">
        <div class="csd-status-legends">
          <ul class="flex gap-2">
            <li class="flex gap-1"><csd-status-icon status="validated" /> Validado</li>
            <li class="flex gap-1"><csd-status-icon status="pending_validation" /> Pendiente de validación</li>
            <li class="flex gap-1"><csd-status-icon status="error" /> Error</li>
          </ul>
        </div>
        <vs-table stripe :data="result.items">
          <template slot="thead">
            <vs-th>F. CSD</vs-th>
            <vs-th>CSD status</vs-th>
            <vs-th>CID</vs-th>
            <vs-th>PID</vs-th>
            <vs-th>RFC</vs-th>
            <vs-th>Nombre</vs-th>
            <vs-th>No. Inv.</vs-th>
            <vs-th>Inv. PF</vs-th>
            <vs-th>Inv. PM</vs-th>
            <vs-th>XML retención</vs-th>
            <vs-th>XML por terceros</vs-th>
            <vs-th>Amortización</vs-th>
            <vs-th>Interés</vs-th>
            <vs-th>Retiro</vs-th>
            <vs-th>IVA</vs-th>
            <vs-th>Retención IVA</vs-th>
            <vs-th>Retención ISR</vs-th>
            <vs-th>I. Retención IVA</vs-th>
            <vs-th>I. Retención ISR</vs-th>
            <vs-th></vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
                v-for="item in data">
              <vs-td>{{item.csd.created_at}}</vs-td>
              <vs-td>
                <csd-status-icon
                    :status-description="item.csd.status_description"
                    :status="item.csd.status" />
              </vs-td>
              <vs-td>{{item.client_id}}</vs-td>
              <vs-td>{{item.project_ids.join(", ")}}</vs-td>
              <vs-td>{{item.rfc}}</vs-td>
              <vs-td>{{item.fiscal_name}}</vs-td>
              <vs-td>{{item.investor_summary.total}}</vs-td>
              <vs-td>{{item.investor_summary.pf}}</vs-td>
              <vs-td>{{item.investor_summary.pm}}</vs-td>
              <vs-td
                  :class="{'text-danger': item.investor_summary.pf !== item.monthly_retention_summary.invoice_j && item.applicant_trx_summary.interest_amount > 0}">
                {{item.monthly_retention_summary.invoice_j}}
              </vs-td>
              <vs-td
                  :class="{'text-danger': item.investor_summary.pm > 1 && item.monthly_retention_summary.invoice_f === 0 && item.applicant_trx_summary.interest_amount > 0}">
                {{item.monthly_retention_summary.invoice_f}}
              </vs-td>
              <vs-td>{{item.applicant_trx_summary.amortization_amount | currency}}</vs-td>
              <vs-td>{{item.applicant_trx_summary.interest_amount | currency}}</vs-td>
              <vs-td :class="{'text-warning': item.applicant_trx_summary.interest_amount > 0 && (isWithdrawalDifferent(item))}">
                {{item.retention_amount | currency}}
              </vs-td>
              <vs-td>{{item.applicant_trx_summary.iva_amount | currency}}</vs-td>
              <vs-td
                  :class="{'text-warning': item.applicant_trx_summary.retention_iva_amount !== item.applicant_trx_summary.interest_amount * 0.16}">
                <vx-tooltip :text="`Monto esperado ${toCurrency(item.applicant_trx_summary.interest_amount * 0.16)}`">
                  {{item.applicant_trx_summary.retention_iva_amount | currency}}
                </vx-tooltip>
              </vs-td>
              <vs-td
                :class="{'text-warning': item.applicant_trx_summary.retention_isr_amount !== item.applicant_trx_summary.interest_amount * 0.20}">
                <vx-tooltip :text="`Monto esperado ${toCurrency(item.applicant_trx_summary.interest_amount * 0.20)}`">
                  {{item.applicant_trx_summary.retention_isr_amount | currency}}
                </vx-tooltip>
              </vs-td>
              <vs-td>{{item.investor_trx_summary.retention_iva_amount | currency}}</vs-td>
              <vs-td>{{item.investor_trx_summary.retention_isr_amount | currency}}</vs-td>
              <vs-td>
                <div class="dropdown-button-container">
                  <vs-dropdown v-if="item.applicant_trx_summary.interest_amount > 0">
                    <vs-button class="btn-drop small" icon="expand_more"></vs-button>
                    <vs-dropdown-menu>
                      <vs-dropdown-item
                        @click="showRetroactiveBillingDialogHandler(item)"
                      >
                       Facturación retroactiva
                      </vs-dropdown-item>
                      <vs-dropdown-item
                          v-if="item.csd.status === 'active'"
                          @click="addJobInvoice(item.client_id)">
                        Reenviar facturación
                      </vs-dropdown-item>
                      <vs-dropdown-item
                          v-if="item.monthly_retention_summary.monthly_retention_id !== null"
                          @click="downloadInvoice(item.monthly_retention_summary.monthly_retention_id)">
                        Descargar Facturas
                      </vs-dropdown-item>
                      <vs-dropdown-item
                          v-if="item.monthly_retention_summary.monthly_retention_id !== null"
                          @click="downloadIntegration(item.client_id)">
                        Descargar integración
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-card>
    </template>

    <retroactive-billing
      v-if="retroactiveBillingData !== null"
      :active.sync="showRetroactiveBillingDialog"
      :data="retroactiveBillingData"
      :applicant-id="retroactiveBillingData.client_id"
      :exercise-date="exerciseDate"
    />

    <vs-popup :active.sync="showRevisionDialog">
      <vs-tabs>
        <vs-tab title="Atrx Retenciones IVA & ISR"></vs-tab>
      </vs-tabs>
    </vs-popup>

  </div>
</template>

<script>
import moment from "moment";
import CsdSummaryCard from "@views/admin/retention-dashboard/v2/CsdSummaryCard";
import CsdStatusIcon from "@views/admin/retention-dashboard/v2/CsdStatusIcon";
import {mapState} from "vuex";
import OrderInvoiceAlert from "@views/admin/retention-dashboard/v2/OrderInvoiceAlert.vue";
import RetroactiveBilling from "@views/admin/retention-dashboard/v2/RetroactiveBilling.vue";

export default {
  name: "MonthlyRetentionDashboard",
  components: {RetroactiveBilling, OrderInvoiceAlert, CsdStatusIcon, CsdSummaryCard},
  data: () => ({
    exerciseDate: null,
    result: null,
    showRevisionDialog: false,
    showRetroactiveBillingDialog: false,
    retroactiveBillingData: null
  }),
  computed: {
    ...mapState("auth", ["user"])
  },
  async mounted() {
    this.exerciseDate = moment()
        .subtract(1, 'month')
        .endOf('month')
        .format("Y-MM-DD")

    await this.getSummaryData();
  },
  methods: {
    toCurrency(value) {
      return `$ ${value.toFixed(2)}`
    },
    async getSummaryData() {
      const {data} = await axios.get(`/api/monthly-retention/dashboard?date=${this.exerciseDate}`)
      this.result = data;

      await this.$refs.orderInvoiceAlert.getInvoiceOrderAlert();
    },
    isWithdrawalDifferent(monthlyRetention) {
      return monthlyRetention.retention_amount !==
          (monthlyRetention.applicant_trx_summary.retention_isr_amount + monthlyRetention.applicant_trx_summary.retention_iva_amount)
    },
    downloadInvoice(monthlyRetentionId) {
      if (confirm("¿Esta seguro de descargar las facturas?")) {
        window.open(`${this.ApiDomain}/api/monthly-retention/${monthlyRetentionId}/invoice/download`, '_blank');
      }
    },
    downloadIntegration(applicantId) {
      let month = moment(this.exerciseDate).format("M")
      let year = moment(this.exerciseDate).format("Y")

      let params = "?applicant_id=" + applicantId;
      params += "&month=" + month;
      params += "&e=" + this.exerciseDate;
      params += "&year=" + year;
      params += "&access_token=" + this.user.access_token;

      window.open(`${this.ApiDomain}/api/monthly-retention/invoice-integration/excel${params}`, '_blank')
    },
    async addJobInvoice(applicantId) {
      try {
        if (confirm("¿Esta seguro de poner en cola esta facturación?")) {
          await axios.post(`/api/billing/order-invoice/resend/all`, {
            exercise_date: this.exerciseDate,
            applicant_id: applicantId
          })
          this.$toasted.show("El job se agrego correctamente", {
            type: "success",
            position: "bottom-right",
            duration: 3000
          })
        }
      } catch (e) {
        this.$toasted.show("Hubo un error al agregar el job", { type: "error", position: "bottom-right", duration: 3000 })
      }
    },
    async showRetroactiveBillingDialogHandler(item) {
      this.showRetroactiveBillingDialog = true;
      this.retroactiveBillingData = item;
    }
  }
}
</script>

<style scoped>

</style>
